import { render, staticRenderFns } from "./UpdateStock.vue?vue&type=template&id=36df2646&scoped=true&"
import script from "./UpdateStock.vue?vue&type=script&lang=js&"
export * from "./UpdateStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df2646",
  null
  
)

export default component.exports